import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';
import { LoadingButton } from '@mui/lab';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import Typography from '@material-ui/core/Typography';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import AddIcon from '@material-ui/icons/Add';
import { useSnackbar } from 'notistack';
import { MenuItem, TableFooter, TextField } from '@material-ui/core';
import { Box, TablePagination } from '@mui/material';
import { AuthContext } from '@jumbo/components/context/AuthContext';
import RefreshToken from 'routes/partials/RefreshToken';
// import AgentReqEdit from './AgentReqEdit';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 450,
  },

  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  dialogButtonSection: {
    padding: '8px 20px',
    justifyContent: 'space-between',
  },
  floatRight: {
    position: 'absolute',
    top: 3,
    right: 3,
  },

  container: {
    maxHeight: 'calc(100vh - 330px)',
    overflow: 'auto',
  },

  cellWidth: {
    width: '230px',
  },

  tableHeadStyle: {
    '& th': {
      fontWeight: 600,
      fontSize: '1rem',
      backgroundColor: '#000132',
      color: 'white',
    },
  },

  tableBodyStyle: {
    '& td': {
      padding: '8px 16px',
    },
  },

  detailButton: {
    color: '#C3C8C8',
    // margin: '0 5px',
    // border: '1px solid #C3C8C8',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#F1F1F1' },
  },
  editButton: {
    color: '#00C4B4',
    // margin: '0 5px',
    // border: '1px solid #66BD4E',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#00C4B410' },
  },
  titleStyle: {
    marginBottom: '1rem',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  dialogStyle: {
    width: '600px',
  },
  alignCenter: {
    textAlign: 'center',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  t_row: {
    display: 'flex',
    gap: '20px',
  },
  first: {
    flex: 1,
    padding: '10px',
  },
  second: {
    flex: 3,
    padding: '10px',
  },
  image: {
    cursor: 'zoom-in',
  },
}));

const TierRequest = () => {
  const classes = useStyles();
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const { enqueueSnackbar } = useSnackbar();
  const [list, setList] = useState([]);
  const [allCountry, setAllCountry] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const [allDocumentType, setAllDocumentType] = useState([]);
  const [allOccupation, setAllOccupation] = useState([]);
  const [detailViewItem, setDetailViewItem] = useState({});
  const [openDetailView, setOpenDetailView] = useState(false);
  const [popupImage, setPopupImage] = useState('');

  const [editObj, setEditObj] = useState({});
  const [editIndexNo, setEditIndexNo] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [message, setMessage] = useState('There is no data');
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [addDialog, setAddDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [count, setCount] = useState(0);
  const [addDialogImage, setAddDialogImage] = useState(false);

  const [fullName, setFullName] = useState('');
  const [documentId, setDocumentId] = useState('');
  const [documentTypeId, setDocumentTypeId] = useState('');
  const [occupation, setOccupation] = useState('');
  const [countryId, setCountryId] = useState('');
  const [stateId, setStateId] = useState('');
  const [cityId, setCityId] = useState('');
  const [stage, setStage] = useState('');
  const [username, setUsername] = useState('');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const openAddDialog = () => {
    setAddDialog(true);
  };
  const closeAddDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    setAddDialog(false);
  };

  const openAddDialogImage = () => {
    setAddDialogImage(true);
  };
  const closeAddDialogImage = () => {
    console.log('closeAddDialog');
    setAddDialogImage(false);
  };

  // ==================Delete Dialogue start==============================
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const handleDeleteDialogClickOpen = () => {
    setDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };
  // ==================Delete Dialogue End==============================

  const handleClickOpenDetailView = () => {
    setOpenDetailView(true);
  };

  const handleCloseDetailView = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    setOpenDetailView(false);
  };

  const handleClickView = item => {
    setDetailViewItem(item);
    handleClickOpenDetailView();
  };

  const getListAll = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let uri = `${process.env.REACT_APP_BASE_URL}/api/v1/private/upgrade-request?page=${page}&size=${perPage}`;
    let url = new URL(uri);

    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        setList(response.data.content);
        setCount(response.data.totalElements);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
    setLoading(false);
  };

  const handleApprove = async id => {
    setLoading(true);
    let data = {};
    // return console.log(data);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    // return console.log('url', `/api/v1/private/allow-upgrade-request/${id}`);
    try {
      let response = await axios({
        url: `/api/v1/private/allow-upgrade-request/${id}`,
        method: 'PUT',
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // clearStates();

      handleSnakbarOpen(response.data, 'success');
      getListAll();
      setOpenDetailView(false);
    } catch (error) {
      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    // return console.log('handleDeleteID', deleteId);
    setLoadingDelete(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .delete(`/api/v1/private/deny-upgrade-request/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        console.log('res.id', response);
        let newList = list.filter(res => res.requestId !== deleteId);
        console.log('newList', newList);
        setList(newList);
        setDeleteDialog(false);
        handleSnakbarOpen(response.data.message, 'success');
      })
      .catch(function(error) {
        // handle error
        setDeleteDialog(false);
        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      });
    setLoadingDelete(false);
  };

  const formatText = str => {
    let text = str.replaceAll('_', ' ');
    return text;
  };

  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 20; i++) {
      content.push(
        <TableRow key={i}>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };

  useEffect(() => {
    getListAll();
  }, [page]);

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle} spacing={3}>
        <Grid item md={8}>
          <Typography variant="h2">Tier Upgrade Request</Typography>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          {/* <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button> */}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer component={Paper} className={classes.container}>
              <Table stickyHeader aria-label="simple table">
                <TableHead className={classes.tableHeadStyle}>
                  <TableRow>
                    <TableCell align="left">Tier Name</TableCell>
                    <TableCell align="left">User Name</TableCell>
                    <TableCell align="left">Request Status</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="center" className={classes.cellWidth}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.tableBodyStyle}>
                  {list.length > 0 && !loading
                    ? list.map((row, i) => (
                        <TableRow hover key={i}>
                          <TableCell align="left" scope="row">
                            {row.tierName}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.userName}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.requestStatus}
                          </TableCell>
                          <TableCell>
                            <img src={row.status ? '/images/ok6.svg' : '/images/cross6.svg'} alt="" height="20px" />
                          </TableCell>

                          <TableCell align="center">
                            <IconButton className={classes.detailButton} onClick={() => handleClickView(row)}>
                              <VisibilityIcon />
                            </IconButton>
                            {/* <IconButton
                              className={classes.editButton}
                              onClick={() => {
                                setEditIndexNo(i);
                                getById(row.id);
                              }}>
                              <EditIcon />
                            </IconButton> */}
                            <IconButton
                              color="secondary"
                              onClick={() => {
                                handleDeleteDialogClickOpen();
                                setDeleteId(row.requestId);
                              }}>
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    : null}
                  {!loading && list.length === 0 && (
                    <TableRow>
                      <TableCell colSpan="10" style={{ textAlign: 'center' }}>
                        {message}
                      </TableCell>
                    </TableRow>
                  )}
                  {loading && pageLoading()}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              rowsPerPageOptions={[]}
              count={count}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={perPage}
            />
          </Paper>
        </Grid>
      </Grid>

      <div>
        <Dialog
          open={openDetailView}
          onClose={handleCloseDetailView}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent>
            {detailViewItem ? (
              <Box>
                <TableContainer style={{ marginBottom: '40px' }}>
                  <div className={classes.titleDiv}>
                    <div className={classes.iconDiv}>
                      <IconButton
                        style={{ background: 'gainsboro' }}
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={handleCloseDetailView}>
                        <Clear fontSize="inherit" />
                      </IconButton>
                    </div>

                    <Typography variant="h1" className={` ${classes.alignCenter}`}>
                      Details
                    </Typography>
                  </div>
                  <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                      <TableRow>
                        <TableCell scope="row" />
                        <TableCell align="right" />
                      </TableRow>
                      <TableRow>
                        <TableCell scope="row"> Name</TableCell>
                        <TableCell align="right">{detailViewItem.userName}</TableCell>
                      </TableRow>

                      {detailViewItem.tierRequiredDocument &&
                        detailViewItem.tierRequiredDocument.length > 0 &&
                        detailViewItem.tierRequiredDocument.map((item, index) => (
                          <React.Fragment key={index}>
                            {item.documentFields.map((req, ind) => (
                              <TableRow key={ind}>
                                <TableCell scope="row">
                                  <p style={{ textTransform: 'capitalize' }}>{formatText(req.key)}</p>
                                </TableCell>
                                <TableCell align="right">
                                  {req.key === 'front_page' || req.key === 'back_page' ? (
                                    <img
                                      src={req.value}
                                      alt=""
                                      className={classes.image}
                                      onClick={() => {
                                        setPopupImage(req.value);
                                        openAddDialogImage();
                                      }}
                                    />
                                  ) : (
                                    req.value
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}

                            <TableRow>
                              <TableCell scope="row" colSpan="2" style={{ borderBottom: '2px solid #666' }} />
                            </TableRow>
                          </React.Fragment>
                        ))}
                    </TableBody>
                  </Table>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: 2,
                    }}>
                    {!detailViewItem.status && (
                      <LoadingButton
                        color="secondary"
                        variant="contained"
                        loading={loading}
                        onClick={() => {
                          handleApprove(detailViewItem.requestId);
                        }}>
                        Approve
                      </LoadingButton>
                    )}
                  </Box>
                </TableContainer>
              </Box>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
      {/* ================== Image Dialog start============================== */}
      <div>
        <Dialog
          maxWidth="md"
          open={addDialogImage}
          onClose={closeAddDialogImage}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyleImage}>
            <IconButton onClick={closeAddDialogImage} style={{ float: 'right' }}>
              <CloseOutlinedIcon />
            </IconButton>
            <div style={{ textAlign: 'center' }}>
              <img src={popupImage} alt="" style={{ maxWidth: '100%', margin: 'auto' }} />
            </div>
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Add Dialog start============================== */}

      <div>
        <Dialog
          open={addDialog}
          onClose={closeAddDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            {/* <AgentReqEdit
              list={list}
              allCountry={allCountry}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            /> */}
          </DialogContent>
        </Dialog>
      </div>

      {/* ==================Add Dialog End============================== */}

      {/* ==================Delete Dialogue start============================== */}
      <div>
        <Dialog
          open={deleteDialog}
          onClose={handleDeleteDialogClose}
          PaperProps={{
            style: {
              minWidth: '400px',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: '20px',
            },
          }}>
          <DialogContent>
            <DialogTitle>
              <Typography variant="h3">Are you sure to delete ?</Typography>
            </DialogTitle>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose} variant="outlined">
              Cancel
            </Button>
            <LoadingButton loading={loadingDelete} onClick={handleDelete} autoFocus variant="contained" color="secondary">
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
      {/* ==================Delete Dialogue End============================== */}
    </React.Fragment>
  );
};

export default TierRequest;
